import { ticketType } from '@agentcall/core/type'

type TicketUpperCategory = {
  id: ticketType.category
  name: string
  ticketLowerCategories: TicketLowerCategory[]
}

export type TicketLowerCategory = {
  id: ticketType.subCategory
  name: string
}

export const ticketUpperCategories: TicketUpperCategory[] = [
  {
    id: ticketType.TICKET_CATEGORY_TOIAWASE,
    name: '問い合せ',
    ticketLowerCategories: [
      {
        id: ticketType.TICKET_SUBCATEGORY_KAGI_AUTOROKKU,
        name: '鍵・オートロック',
      },
      {
        id: ticketType.TICKET_SUBCATEGORY_MERUBOKKUSU_TAKUHAI_BOKKUSU,
        name: 'メールボックス・宅配ボックス',
      },
      {
        id: ticketType.TICKET_SUBCATEGORY_INTANETTO_TEREBI_DENWA,
        name: 'インターネット・テレビ・電話',
      },
      {
        id: ticketType.TICKET_SUBCATEGORY_EAKON_KANREN,
        name: 'エアコン関連',
      },
      {
        id: ticketType.TICKET_SUBCATEGORY_SETSUBI_KANREN_SHIYO_HOHO_TO,
        name: '設備関連（使用方法等）',
      },
      {
        id: ticketType.TICKET_SUBCATEGORY_CHUSHAJO_CHURINJO,
        name: '駐車場・駐輪場',
      },
      {
        id: ticketType.TICKET_SUBCATEGORY_YACHIN_SUIDO_DAI,
        name: '家賃・水道代',
      },
      { id: ticketType.TICKET_SUBCATEGORY_HOSHO_GAISHA, name: '保証会社' },
      { id: ticketType.TICKET_SUBCATEGORY_SHORUI_KANKEI, name: '書類関係' },
      { id: ticketType.TICKET_SUBCATEGORY_HOKEN, name: '保険' },
      {
        id: ticketType.TICKET_SUBCATEGORY_KOSHIN_SAIKEIYAKU,
        name: '更新・再契約',
      },
      {
        id: ticketType.TICKET_SUBCATEGORY_MEIGI_HENKO,
        name: '名義変更',
      },
      {
        id: ticketType.TICKET_SUBCATEGORY_NYUKYOSHA_JOHO_HENKO,
        name: '入居者情報変更',
      },
      {
        id: ticketType.TICKET_SUBCATEGORY_RAIFURAIN,
        name: 'ライフライン',
      },
      { id: ticketType.TICKET_SUBCATEGORY_KYOJU_RURU, name: '居住ルール' },
      {
        id: ticketType.TICKET_SUBCATEGORY_ANPI_KYOJU_KAKUNIN,
        name: '安否・居住確認',
      },
      { id: ticketType.TICKET_SUBCATEGORY_SONOTA_TOIAWASE, name: 'その他' },
    ],
  },
  {
    id: ticketType.TICKET_CATEGORY_KAIYAKU_KANREN,
    name: '解約関連',
    ticketLowerCategories: [
      {
        id: ticketType.TICKET_SUBCATEGORY_KAIYAKU_TETSUZUKI_HOHO,
        name: '解約手続き方法',
      },
      {
        id: ticketType.TICKET_SUBCATEGORY_KAIYAKU_BI_HENKO_TORIKESHI,
        name: '解約日変更・取消',
      },
      {
        id: ticketType.TICKET_SUBCATEGORY_TAIKYO_TACHIAI,
        name: '退去立会い',
      },
      {
        id: ticketType.TICKET_SUBCATEGORY_TAIKYO_SEISAN,
        name: '退去精算',
      },
      {
        id: ticketType.TICKET_SUBCATEGORY_SHIKIKIN_HENKIN_KOZA_TENKYO_SAKI_JUSHO,
        name: '敷金返金口座・転居先住所',
      },
    ],
  },
  {
    id: ticketType.TICKET_CATEGORY_KUREMU_HADO,
    name: 'クレームハード',
    ticketLowerCategories: [
      {
        id: ticketType.TICKET_SUBCATEGORY_EAKON,
        name: 'エアコン',
      },
      {
        id: ticketType.TICKET_SUBCATEGORY_KYUTOKI,
        name: '給湯器',
      },
      {
        id: ticketType.TICKET_SUBCATEGORY_NYUKYOJI_FUGUAI,
        name: '入居時不具合',
      },
      {
        id: ticketType.TICKET_SUBCATEGORY_MIZUMAWARI,
        name: '水回り',
      },
      {
        id: ticketType.TICKET_SUBCATEGORY_TOIRE_WOSHURETTO,
        name: 'トイレ・ウォシュレット',
      },
      { id: ticketType.TICKET_SUBCATEGORY_ROSUI, name: '漏水' },
      {
        id: ticketType.TICKET_SUBCATEGORY_INTAHON_CHAIMU,
        name: 'インターホン・チャイム',
      },
      {
        id: ticketType.TICKET_SUBCATEGORY_KONRO,
        name: 'コンロ',
      },
      {
        id: ticketType.TICKET_SUBCATEGORY_TATEGU,
        name: '建具',
      },
      { id: ticketType.TICKET_SUBCATEGORY_TEREBI, name: 'テレビ' },
      {
        id: ticketType.TICKET_SUBCATEGORY_INTANETTO,
        name: 'インターネット',
      },
      {
        id: ticketType.TICKET_SUBCATEGORY_KYOYOBU,
        name: '共用部',
      },
      {
        id: ticketType.TICKET_SUBCATEGORY_KAGI_GENKAN,
        name: '鍵（玄関）',
      },
      {
        id: ticketType.TICKET_SUBCATEGORY_KANKI_KANREN,
        name: '換気関連',
      },
      {
        id: ticketType.TICKET_SUBCATEGORY_SHOMEI_KIGU,
        name: '照明器具',
      },
      {
        id: ticketType.TICKET_SUBCATEGORY_BUREKA_DENKI_KANREN,
        name: 'ブレーカー・電気関連',
      },
      {
        id: ticketType.TICKET_SUBCATEGORY_KEIHOKI,
        name: '警報器',
      },
      {
        id: ticketType.TICKET_SUBCATEGORY_KUROSU_YUKA_TATAMI,
        name: 'クロス・床・畳',
      },
      {
        id: ticketType.TICKET_SUBCATEGORY_KABI_KETSURO,
        name: 'カビ・結露',
      },
    ],
  },
  {
    id: ticketType.TICKET_CATEGORY_KUREMU_SOFUTO,
    name: 'クレームソフト',
    ticketLowerCategories: [
      {
        id: ticketType.TICKET_SUBCATEGORY_CHUSHAJO,
        name: '駐車場',
      },
      {
        id: ticketType.TICKET_SUBCATEGORY_CHURINJO,
        name: '駐輪場',
      },
      { id: ticketType.TICKET_SUBCATEGORY_SO_ON, name: '騒音' },
      {
        id: ticketType.TICKET_SUBCATEGORY_GOMI,
        name: 'ゴミ',
      },
      { id: ticketType.TICKET_SUBCATEGORY_SHOKUBUTSU, name: '植物' },
      { id: ticketType.TICKET_SUBCATEGORY_SEIBUTSU, name: '生物' },
      {
        id: ticketType.TICKET_SUBCATEGORY_KITSUEN,
        name: '喫煙',
      },
      { id: ticketType.TICKET_SUBCATEGORY_NIOI, name: 'におい' },
      {
        id: ticketType.TICKET_SUBCATEGORY_KYOYOBU_NO_SHIYO_NI_TSUITE_SHIBUTSU,
        name: '共用部の使用について（私物）',
      },
      {
        id: ticketType.TICKET_SUBCATEGORY_KYOUBU_NO_YOGORE_SEISO,
        name: '共用部の汚れ・清掃',
      },
    ],
  },
  {
    id: ticketType.TICKET_CATEGORY_SONOTA,
    name: 'その他',
    ticketLowerCategories: [
      { id: ticketType.TICKET_SUBCATEGORY_SONOTA, name: 'その他' },
    ],
  },
  {
    id: ticketType.TICKET_CATEGORY_SABISU_NI_TSUITE,
    name: 'サービスについて',
    ticketLowerCategories: [
      {
        id: ticketType.TICKET_SUBCATEGORY_SABISU_TOIAWASE,
        name: 'サービス問合せ',
      },
    ],
  },
  {
    id: ticketType.TICKET_CATEGORY_SHINKI_NYUKYOSHA_SHONIN,
    name: '新規入居者承認',
    ticketLowerCategories: [
      {
        id: ticketType.TICKET_SUBCATEGORY_SHINKI_KEIYAKU_SHONIN_KAKUNIN,
        name: '新規契約承認確認',
      },
    ],
  },
  {
    id: ticketType.TICKET_CATEGORY_KAIYAKU_UKETSUKE,
    name: '解約受付',
    ticketLowerCategories: [
      {
        id: ticketType.TICKET_SUBCATEGORY_KAIYAKU_UKETSUKE_KAKUNIN,
        name: '解約受付確認',
      },
    ],
  },
] as const

export const getTicketUpperCategory = (
  ticketUpperCategoryId: TicketUpperCategory['id'],
): TicketUpperCategory | undefined => {
  return ticketUpperCategories.find(
    (ticketUpperCategory) => ticketUpperCategory.id === ticketUpperCategoryId,
  )
}

export const getTicketLowerCategory = (
  ticketUpperCategoryId: TicketUpperCategory['id'],
  ticketLowerCategoryId: TicketLowerCategory['id'],
): TicketLowerCategory | undefined => {
  const ticketUpperCategory = getTicketUpperCategory(ticketUpperCategoryId)
  if (!ticketUpperCategory) {
    return undefined
  }
  return ticketUpperCategory.ticketLowerCategories.find(
    (ticketLowerCategory) => ticketLowerCategory.id === ticketLowerCategoryId,
  )
}
